{
  "version": 1,
  "asset_id": "0bb3f242-f201-4b3b-a27b-4b70ba9f1097",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0bb3f242-f201-4b3b-a27b-4b70ba9f1097/dilated-pouch-boxed-es-480.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0bb3f242-f201-4b3b-a27b-4b70ba9f1097/dilated-pouch-boxed-es-480.jpg",
  "original_filename": "dilated-pouch-boxed-es-480.jpg",
  "size": 45362,
  "content_type": "image/jpeg",
  "created_at": "2026-10-06T14:09:05Z"
}
